import { useEffect } from 'react';
import { HOSTING_URL } from '../lib/site';

/** /hosting bookmarks go to the dedicated Hosting site. The Hub carries no hosting content. */
export const RedirectToHosting: React.FC = () => {
  useEffect(() => {
    window.location.replace(HOSTING_URL);
  }, []);
  return (
    <p className="page-inner py-10 text-secondary-400">
      Taking you to the Hosting site… <a className="text-primary-300 underline underline-offset-4" href={HOSTING_URL}>Continue</a>
    </p>
  );
};
